exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".FeatureStatusIndicator__featureStatusIndicator___2Fi9H{height:.2em;width:100%}", "", {"version":3,"sources":["/opt/TeamCity/buildAgentTest/work/87d7e5c6c6455c0d/packages/common/components/featureStatusIndicator/FeatureStatusIndicator.scss"],"names":[],"mappings":"AAAA,wDACE,YACA,UAAA,CAAA","file":"FeatureStatusIndicator.scss","sourcesContent":[".featureStatusIndicator {\n  height: 0.2em;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"featureStatusIndicator": "FeatureStatusIndicator__featureStatusIndicator___2Fi9H"
};